<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 头部 -->
		<div class="titleView">
			<div style="margin-right: 20px;display: flex;align-items: center;">
				<el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput"
					clearable size="small" />
				<el-button type="warning" style="margin-left: 10px;" @click="getTableData" size="small">搜索</el-button>
			</div>
			<div class="flex" v-if="comTab == 0">
				<div style="margin-right: 10px;">申请日期</div>
				<el-date-picker v-model="dateValue" type="daterange" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期" class="titleDate" @change="handleChange"
					:default-time="['00:00:00','23:59:59']" value-format="timestamp" style="width: 224px;"
					size="small" />
			</div>
			<div class="flex">
				<div style="margin-right: 10px;">状态</div>
				<el-select v-model="orderStatus" placeholder="请选择" class="titleSelect" @change="handleChange"
					style="width: 126px;" size="small">
					<el-option v-for="item in orderStatuss" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</div>
			<div style="text-align: right;flex: 1;">
				<el-button @click="handleResetClick" size="small">重置</el-button>
				<el-button @click="handleNavWuliaoClick(0)" size="small" type="warning">申请物料</el-button>
			</div>
		</div>

		<!-- tab切换 -->
		<div class="tabLine">
			<div class="tabItem" :class="[comTab==0?'active':'']" @click="handleTabClick(0)">采购列表</div>
			<div class="tabItem" :class="[comTab==1?'active':'']" @click="handleTabClick(1)">验收列表</div>
		</div>

		<!-- 表格 -->
		<div class="tableView">
			<!-- 采购列表 -->
			<el-table :data="tableData" style="width: 100%" key="0" v-if="comTab == 0">
				<el-table-column prop="orderNo" label="申请单号">
				</el-table-column>
				<el-table-column prop="applyTime" label="申请日期">
				</el-table-column>
				<el-table-column prop="applier.userName" label="申请人">
				</el-table-column>
				<el-table-column prop="remark" label="备注">
					<template slot-scope="scope">
						{{scope.row.remark == ''?'--':scope.row.remark}}
					</template>
				</el-table-column>
				<el-table-column prop="orderStatus.name" label="状态">
				</el-table-column>
				<el-table-column label="审批人">
					<template slot-scope="scope">
						{{scope.row.applyOrderApproveUser == null?'--':scope.row.applyOrderApproveUser.userName}}
					</template>
				</el-table-column>
				<el-table-column prop="applyOrderApproveTime" label="审批日期">
					<template slot-scope="scope">
						{{scope.row.applyOrderApproveTime == null?'--':scope.row.applyOrderApproveTime}}
					</template>
				</el-table-column>
				<el-table-column label="审批说明">
					<template slot-scope="scope">
						{{scope.row.applyOrderApproveRemark == null?'--':scope.row.applyOrderApproveRemark}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<el-button @click="handleDrawerMCaigouClick(scope.row)" type="text" size="small">查看</el-button>
						<el-button type="text" size="small" v-if="scope.row.orderStatus.id == '0'" @click="handleNavWuliaoClick(1,scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			
			<!-- 验收列表 -->
			<el-table :data="tableData" style="width: 100%" key="1" v-if="comTab == 1">
				<el-table-column prop="date" label="分拨单号">
				</el-table-column>
				<el-table-column prop="name" label="分拨日期">
				</el-table-column>
				<el-table-column prop="address" label="分拨人">
				</el-table-column>
				<el-table-column prop="address" label="状态">
				</el-table-column>
				<el-table-column prop="address" label="验收人">
				</el-table-column>
				<el-table-column prop="address" label="验收日期">
				</el-table-column>
				<el-table-column prop="address" label="验收备注">
				</el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
						<el-button type="text" size="small">验货</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<page :page="page.page" :total="page.total" @change="changePage" style="padding: 10px 0;"></page>
		</div>
		
		<!-- 查看弹框 -->
		<div v-if="drawerMCaigouSee_state">
			<drawerMCaigouSee @closeOn="drawerMCaigouSee_state = false" :comState="drawerMCaigouSee_state" :navId="navId"></drawerMCaigouSee>
		</div>
		
	</div>
</template>

<script>
	import page from "../../../../components/page.vue"
	import drawerMCaigouSee from "../drawer/drawerMCaigouSee.vue"
	export default {
		components: {
			page,
			drawerMCaigouSee
		},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				fixedHeight: '',
				shopOptions: [{ //门店筛选
					value: '',
					label: '全部'
				}, {
					value: '5e9412e0b2bfbc089daerr12',
					label: '金水区店'
				}, {
					value: '5e9412e0b2bfbc089daerr18',
					label: '郑东新区店'
				},{
					value: '5e9412e0b2bfbc089daerr14',
					label: '指挥中心店'
				}],
				comTab: 0,
				tableData: [],
				orderStatus:'',  //状态
				dateValue:[],  //申请日期
				orderStatuss:[{label:'待提交',value:'0'},{label:'审批中',value:'1'},{label:'已同意',value:'2'},{label:'已驳回',value:'-1'}],
				keyword:'',
				drawerMCaigouSee_state:false,  //弹框
				navId:'',  //采购列表查看数据
			}
		},
		created() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
		},
		mounted() {
			this.getTableData()
		},
		methods: {
			//门店查看弹框
			handleDrawerMCaigouClick(row){
				this.navId = row.id;
				this.drawerMCaigouSee_state = true;
			},
			//重置
			handleResetClick(){
				this.keyword = '';
				this.orderStatus = '';
				if(this.comTab == 0){
					this.dateValue = [];
				}
				this.getTableData()
			},
			handleChange(){
				this.page.page = 1;
				this.getTableData()
			},
			//跳转申请物料
			handleNavWuliaoClick(type,row){
				if(type == 0){
					this.$router.push({path: 'updateWuliao'})
				}else{
					let query = {
						id:row.id
					}
					this.$router.push({path: 'updateWuliao',query})
				}
			},
			//表格
			getTableData() {
				if(this.comTab == 0){   //采购列表
					let params = {
						pageIndex:this.page.page,
						pageSize:this.page.pageSize,
						keyword:this.keyword,
						shopId:this.$store.getters.curShopInfo.shop_id,
						orderStatus:this.orderStatus
					}
					if(this.dateValue.length == 0){
						params.startTime = '';
						params.endTime = '';
					}else{
						params.startTime = this.$public.FTime(this.dateValue[0]/1000,'YYYY-MM-DD')
						params.endTime = this.$public.FTime(this.dateValue[1]/1000,'YYYY-MM-DD')
					}
					this.$http.post(process.env.VUE_APP_Url_8022 + '/api/PurchaseApply/List',params).then(
						res => {
							if (res.code == 0) {
								console.log('采购列表',res.data)
								this.tableData = res.data.list;
								this.page.total = res.data.count;
							}
						})
				}else{  //验收列表
					let params = {
						pageIndex:this.page.page,
						pageSize:this.page.pageSize,
						keyword:this.keyword,
						shopId:this.$store.getters.curShopInfo.shop_id,
						orderStatus:this.orderStatus
					}
					this.$http.post(process.env.VUE_APP_Url_8022 + '/api/Assign/List',params).then(
						res => {
							if (res.code == 0) {
								console.log('验收列表',res.data)
								this.tableData = res.data.list;
								this.page.total = res.data.count;
							}
						})
				}
			},
			//分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//tab切换
			handleTabClick(tab) {
				this.comTab = tab;
				this.orderStatus = '';
				this.keyword = '';
				this.getTableData()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		display: flex;
		flex-direction: column;

		.flex {
			display: flex;
			align-items: center;
			margin-right: 10px;
		}

		.titleView {
			background: #fff;
			height: 72px;
			display: flex;
			align-items: center;
			font-size: 14px;
			padding: 0 10px;
		}

		.tabLine {
			display: flex;
			margin: 10px 0;

			.tabItem {
				width: 100px;
				box-sizing: border-box;
				line-height: 36px;
				text-align: center;
				border-right: 1px solid #F2F2F2;
				cursor: pointer;
				font-size: 14px;
				background-color: #fff;

				&.active {
					color: $mainColor;
				}
			}
		}

		.tableView {
			flex: 1;
			background: #fff;
			overflow-y: scroll;
		}

		.tableView::-webkit-scrollbar {
			display: none;
		}
	}
</style>
